import type { PopupProps } from '@atlaskit/popup';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy, LoadablePaint } from '@confluence/loadable';
import type { ReactNode } from 'react';
import type { ChangeEditionSectionMessageContentRestrictedProps } from '../SectionMessage/ChangeEditionSectionMessageContentRestricted.tsx';

/**
 * @deprecated Please reach out to #cc-ai-growth for details before use. Please read https://hello.atlassian.net/wiki/spaces/CE2/pages/2797298237/Contribution+Consumption+Guidelines+For+Common+Feature+Gate+Upsell+Component
 */
export const ChangeEditionInlineDialogLoader: LoadableType<
	{
		onClose?(): void;
	} & Pick<ChangeEditionSectionMessageContentRestrictedProps, 'isChildPage' | 'parentData'> &
		Pick<PopupProps, 'isOpen' | 'placement'> & {
			children?: ReactNode | undefined;
		}
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ChangeEditionInlineDialog" */ './ChangeEditionInlineDialog.tsx'
			)
		).ChangeEditionInlineDialog,
});

/**
 * @deprecated Please reach out to #cc-ai-growth for details before use. Please read https://hello.atlassian.net/wiki/spaces/CE2/pages/2797298237/Contribution+Consumption+Guidelines+For+Common+Feature+Gate+Upsell+Component
 */
export const ChangeEditionInlineDialogPaintLoader: LoadableType<
	{
		onClose?(): void;
	} & Pick<ChangeEditionSectionMessageContentRestrictedProps, 'isChildPage' | 'parentData'> &
		Pick<PopupProps, 'isOpen' | 'placement'> & {
			children?: ReactNode | undefined;
		}
> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ChangeEditionInlineDialog" */ './ChangeEditionInlineDialog.tsx'
			)
		).ChangeEditionInlineDialog,
});
